import { getLandingOrigin } from "@/config/landingOrigin";

/** Public marketing site (landing SPA) — “Back to Paylio” and legal links. */
export function getMarketingHomeHref() {
  const o = getLandingOrigin();
  if (o) return `${o}/`;
  if (import.meta.env.DEV) return "http://localhost:3000/";
  return "/";
}

export function getMarketingPageHref(path) {
  const o = getLandingOrigin();
  const p = path.startsWith("/") ? path : `/${path}`;
  if (o) return `${o}${p}`;
  if (import.meta.env.DEV) return `http://localhost:3000${p}`;
  return p;
}
